import Button from "@components/common/Button";
import { ToggleSwitch } from "flowbite-react";
import { useState } from "react";
import { customThemeToggleSwitch } from "styles/customTheme";

const FiltersCard = ({ filters }) => {
	const [items, setItems] = useState(filters);

	const toggleFilter = (id) =>
		setItems((prev) => prev.map((f) => (f.id === id ? { ...f, enabled: !f.enabled } : f)));

	return (
		<div className="overflow-hidden rounded-xl bg-[#171a35] shadow-lg ring-1 ring-white/5">
			<div className="flex items-center justify-between gap-2 border-slate-700 border-b px-5 py-4">
				<h1 className="text-start font-semibold text-slate-100 text-xs tracking-wide sm:text-sm">
					Filters
				</h1>
				<Button text="Apply filters" className="!px-4 !py-2.5 text-white" />
			</div>
			<div className="p-4">
				<div className="flex flex-col divide-y divide-white/5">
					{items.map((filter) => (
						<div
							key={filter.id}
							className="flex items-start justify-between gap-4 py-4 first:pt-0 last:pb-0"
						>
							<div className="text-start">
								<p className="text-start font-medium text-[10px] text-slate-100 sm:text-xs">
									{filter.name}
								</p>
								<p className="mt-1 text-slate-400 text-xs">{filter.description}</p>
								{filter.status && (
									<span className="mt-2 inline-block rounded-md border border-blue-gray bg-blue-gray/30 px-3 py-1 font-medium text-gray-400 text-xs">
										{filter.status}
									</span>
								)}
							</div>
							<div className="text-right">
								<ToggleSwitch
									theme={customThemeToggleSwitch}
									color="green"
									checked={filter.enabled}
									onChange={() => toggleFilter(filter.id)}
								/>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
export default FiltersCard;
